"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TagCustomerConfigurationEntity_1 = __importDefault(require("./Entity/TagCustomerConfigurationEntity"));
var TagCustomerConfiguration = /** @class */ (function () {
    function TagCustomerConfiguration(session) {
        this.tagCustomerConfiguration = new TagCustomerConfigurationEntity_1.default(session);
    }
    TagCustomerConfiguration.prototype.getByTag = function (tagId) {
        return this.tagCustomerConfiguration.getByTag(tagId);
    };
    TagCustomerConfiguration.prototype.getAll = function () {
        return this.tagCustomerConfiguration.service.getAll();
    };
    TagCustomerConfiguration.prototype.create = function (tagId, tagCustomerConfiguration) {
        return this.tagCustomerConfiguration.service.create(__assign(__assign({}, tagCustomerConfiguration), { tag_id: tagId }));
    };
    TagCustomerConfiguration.prototype.update = function (id, tagCustomerConfiguration) {
        return this.tagCustomerConfiguration.service.update(id, tagCustomerConfiguration);
    };
    TagCustomerConfiguration.prototype.delete = function (id) {
        return this.tagCustomerConfiguration.service.delete(id);
    };
    return TagCustomerConfiguration;
}());
exports.default = TagCustomerConfiguration;
//# sourceMappingURL=TagCustomerConfiguration.js.map